export const redirectToGoogle = () => {
  window.location.assign('https://google.com');
};
